<template>
    <div class="background-image-wrapper bg-fade" :class="{ 'is-loaded': loaded }">
        <span class="bg-fade__skeleton" aria-hidden="true" />
        <div class="bg-fade__image" :style="loaded ? { backgroundImage: `url(${src})` } : {}" role="img" :aria-label="alt" />
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';

const props = defineProps({
    src: {
        type: String,
        default: '',
    },
    alt: {
        type: String,
        default: '',
    },
});

const loaded = ref(false);

function preload(url) {
    loaded.value = false;
    if (!url) return;
    const img = new Image();
    img.onload = () => {
        loaded.value = true;
    };
    img.onerror = () => {
        loaded.value = true;
    };
    img.src = url;
    if (img.complete) {
        loaded.value = true;
    }
}

onMounted(() => preload(props.src));
watch(() => props.src, (val) => preload(val));
</script>
